import {v1_OrderPriority_select_column} from '../../generated/types';

const OrderPriority = {
    ...v1_OrderPriority_select_column,
    res: 'v1_OrderPriority',
    comp: {},
    rel: {},
};

export default OrderPriority;
